import { render, staticRenderFns } from "./RegionSelect.vue?vue&type=template&id=ed939910"
import script from "./RegionSelect.vue?vue&type=script&lang=js"
export * from "./RegionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports